export interface FocusRect {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

export const computeFocusRect = (focusPolygon: Array<{ x: number; y: number }>): FocusRect => ({
  left: Math.min(...focusPolygon.map((p) => p.x)),
  top: Math.min(...focusPolygon.map((p) => p.y)),
  right: Math.max(...focusPolygon.map((p) => p.x)),
  bottom: Math.max(...focusPolygon.map((p) => p.y)),
});
